import React from 'react';
import { Theme } from '../../../lib/theme';

interface NextButtonProps {
  disabled?: boolean;
  text: string;
  onClick?: (e: React.FormEvent<HTMLButtonElement>) => void;
}

export const NextButton: React.FC<NextButtonProps> = ({
  disabled = false,
  text,
  onClick,
}) => {
  const isSkip = text.toLowerCase() === 'Skip';

  return (
    <button
      type="submit"
      disabled={disabled}
      onClick={onClick}
      style={{
        backgroundColor: disabled
          ? isSkip
            ? Theme.colors.button.primary
            : '#E6EAF0'
          : Theme.colors.button.primary,
        color: disabled
          ? isSkip
            ? Theme.colors.background
            : '#797C81'
          : Theme.colors.text.white,
        height: '3.3rem',
        padding: '0.5rem 1.5rem',
        borderRadius: Theme.radius.base,
        width: '100%',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = Theme.colors.button.hover;
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = Theme.colors.button.primary;
        }
      }}
    >
      {text}
    </button>
  );
};

interface BackButtonProps {
  onClick: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Go back"
      className="px-6 py-2 h-[3.3rem] lg:h-[2.7rem] rounded-xl active:scale-95 transition transform duration-300 w-full"
      style={{
        color: Theme.colors.text.weak,
        border: `1px solid ${Theme.colors.button.disabled}`,
        backgroundColor: 'transparent',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = Theme.colors.primary;
        e.currentTarget.style.color = Theme.colors.background;
        e.currentTarget.style.border = `1px solid ${Theme.colors.primary}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
        e.currentTarget.style.color = Theme.colors.text.weak;
        e.currentTarget.style.border = `1px solid ${Theme.colors.button.disabled}`;
      }}
    >
      Back
    </button>
  );
};
